<template>
  <div class="applyChoice">
    <div class="applyChoiceBoxLeft">
      <div class="applyChoiceDiv">
        <img class="applyChoiceIcon" src="../../assets/img/icon/individualMember.png"/>
        <p class="applyChoiceP">个人会员</p>
        <router-link to="/individualApply"><button class="btn choiceBtn">个人注册</button></router-link>
        <br>
        <a class="explain" @click="personProcess">个人入会流程说明</a>
      </div>
    </div>
    <div class="applyChoiceBoxRight">
      <div class="applyChoiceDiv" style="float: left">
        <img class="applyChoiceIcon" src="../../assets/img/icon/corporateMember.png"/>
        <p class="applyChoiceP">企业会员</p>
        <router-link to="/enterpriseApply"><button class="btn choiceBtn">企业注册</button></router-link>
        <br>
        <a class="explain" @click="enterpriseProcess">企业入会流程说明</a>
      </div>
    </div>
    <a>已有账号，马上</a><router-link to="/onload">登陆</router-link>
  </div>
</template>
<script>
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'
import HttpServer from '@/utils' // 接口请求

export default {
  name: 'choiceApply',
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
    // 下载个人入会流程说明
    personProcess: function () {
      HttpServer.get('http://api.gdics.cn/api/download_file').then(res => {
        window.location.href = res.msg[0].path
      })
    },

    // 下载企业入会流程说明
    enterpriseProcess: function () {
      HttpServer.get('http://api.gdics.cn/api/download_file').then(res => {
        console.log(res)
        window.location.href = res.msg[1].path
      })
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .applyChoice{
    min-width: 950px;
  }
  .applyChoiceBoxLeft{
    width: 50%;
    height: 380px;
    float: left;
  }
  .applyChoiceBoxRight{
    width: 50%;
    height: 380px;
    float: right;
  }
  .applyChoiceDiv{
    width: 300px;
    height: 370px;
    float: right;
  }
  .applyChoiceIcon{
    margin-top: 50px;
    width: 110px;
    height: 110px;
  }
  .applyChoiceP{
    margin-top: 30px;
    font-size: 24px;
    font-family: '微软雅黑';
  }
  .choiceBtn{
    width:130px;
    margin-top:50px;
    color:#ffffff;
    background-color: #0064e6;
  }
  .explain{
    font-size: 11px;
    cursor: pointer;
    color: #007bff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/apply/choiceApply.vue